import { Box } from "@mantine/core";
import { useEffect } from "react";

type TSCBlogsIconProps = {
  size?: number;
  isDark?: boolean;
  isHovered?: boolean;
};

// Preload images to prevent lazy load delay
const preloadImages = () => {
  const images = ["/tscblogs.svg", "/tscblogs-stroke.svg", "/tscblogs-stroke-w.svg"];
  images.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};

let imagesPreloaded = false;

export default function TSCBlogsIcon({ size = 18, isDark = false, isHovered = false }: TSCBlogsIconProps) {
  // Preload all images on first mount
  useEffect(() => {
    if (!imagesPreloaded) {
      preloadImages();
      imagesPreloaded = true;
    }
  }, []);

  // Get the stroke version based on theme
  const strokeSrc = isDark ? "/tscblogs-stroke-w.svg" : "/tscblogs-stroke.svg";
  const filledSrc = "/tscblogs.svg";

  return (
    <Box
      sx={{
        width: size,
        height: size,
        position: "relative",
      }}
    >
      {/* Stroke version (default) */}
      <img
        src={strokeSrc}
        alt="TSCBlogs"
        style={{
          width: size,
          height: size,
          position: "absolute",
          top: 0,
          left: 0,
          opacity: isHovered ? 0 : 1,
          transition: "opacity 0.2s ease-in-out",
        }}
      />
      {/* Filled version (hover) */}
      <img
        src={filledSrc}
        alt="TSCBlogs"
        style={{
          width: size,
          height: size,
          position: "absolute",
          top: 0,
          left: 0,
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s ease-in-out",
        }}
      />
    </Box>
  );
}

